// extracted by mini-css-extract-plugin
export default {"heading":"uv-z","corrected":"vv-z","redirectVerbiageContainer":"wv-z","redirectVerbiageText":"xv-z"};